import React from 'react'
import { usePlayrooms } from '../context/PlayroomsContext'
import { Card } from 'antd';
import Meta from 'antd/es/card/Meta';
import { EnvironmentOutlined, PhoneOutlined } from '@ant-design/icons';
import PremiumIcon from '../icons/PremiumIcon';

export default function PlayroomCard() {

  const { choosenPlayroom } = usePlayrooms();
  return (
    <div>
      <Card
        key={choosenPlayroom.id}
        className="h-auto shadow-lg flex flex-col justify-between rounded-[30px] md:rounded-[40px]"
        // onClick={() => onPlayroomClick(playroom)}
        cover={
          <div className="h-48 sm:h-56 md:h-60 lg:h-64 xl:h-72 overflow-hidden">
            <img
              alt={choosenPlayroom.name}
              src={choosenPlayroom.photos[0]?.photoUrl}
              className="w-full h-full object-cover rounded-t-[30px] md:rounded-t-[40px]"
            />
          </div>
        }
      >
        <Meta
          title={
            <div className="grid grid-cols-[80%_20%] gap-2">
              {/* Left side (80%) */}
              <div className="flex flex-col text-left gap-2">
                <span className="text-xl sm:text-3xl lg:text-2xl text-footerBlue font-bold">
                  {choosenPlayroom.name}
                </span>
                <div className="flex items-center text-cardDetailsGray text-sm lg:text-sm gap-1">
                  <EnvironmentOutlined style={{
                    color: "#00223E"
                  }} />
                  <span>{choosenPlayroom.location}</span>
                </div>
                <div className="flex items-center text-cardDetailsGray text-sm lg:text-sm gap-1">
                  <PhoneOutlined style={{
                    color: "#00223E"
                  }} />
                  <span>{choosenPlayroom.contactInfo}</span>
                </div>
              </div>
              {/* Right side (20%) */}
              <div className="flex items-start justify-center p-2">
                {choosenPlayroom.isPremium && (
                  <PremiumIcon />
                )}
              </div>
            </div>
          }
        />
      </Card>
    </div>

  )
}
